import { NgModule } from "@angular/core";
import { MenuItems } from "./menu-items/menu-items";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { CustomPaginator } from "./utils/custom-paginator";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { ConfirmDialogComponent } from "./utils/confirm-dialog/confirm-dialog.component";
import { A11yModule } from "@angular/cdk/a11y";

import { NgApexchartsModule } from "ng-apexcharts";
import { TablerIconsModule } from "angular-tabler-icons";

import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

// Analisi graphs
import { DialogComponent } from "./components/dialog/dialog.component";
import { MaterialModule } from "../material.module";
import { CommonModule } from "@angular/common";
import { DateInputMaskDirective } from "./directives/date-input-mask.directive";
import { ITALIAN_DATE_FORMATS } from "./utils/custom-date-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { ItalianDateAdapter } from "./utils/italian-date-adapter";
import { AlertDialogComponent } from "./components/alert-dialog/alert-dialog.component";
import { TranslateModule } from "@ngx-translate/core";
import {
  AccordionAnchorDirective,
  AccordionDirective,
  AccordionLinkDirective,
} from "./directives/accordion";

@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ConfirmDialogComponent,
    DialogComponent,
  ],
  imports: [
    AlertDialogComponent,
    FormsModule,
    A11yModule,
    MaterialModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    NgxDatatableModule,
    NgxSkeletonLoaderModule,
    NgxMatSelectSearchModule,
    TablerIconsModule,
    DateInputMaskDirective,
    CommonModule,
    TranslateModule,
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ConfirmDialogComponent,
    TranslateModule,
    MaterialModule,
  ],
  providers: [
    MenuItems,
    { provide: MatPaginatorIntl, useClass: CustomPaginator },
    { provide: MAT_DATE_LOCALE, useValue: "it-IT" },
    { provide: MAT_DATE_FORMATS, useValue: ITALIAN_DATE_FORMATS },
    {
      provide: DateAdapter,
      useClass: ItalianDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
  ],
})
export class SharedModule {}
